<template>
    <div class="form-component">
        <v-form ref="form" v-model="valid">
            <h3 class="form-title">
                <v-btn fab color="primary" @click="goTo('/Documentslist')">
                    <v-icon large>arrow_left</v-icon>
                </v-btn>
                {{ title }} Documento
            </h3>
            
            <v-container fluid class="pa-0">
                <h4>Encabezado</h4>
                <v-layout row wrap>
                    <!-- ROW ONE -->
                    <v-flex xs12 sm3>
                        <v-select class="lance"
                            :items="suppliers"
                            item-text="businessName"
                            item-value="code"
                            v-model="form.supplierCode"
                            label="Proveedor"
                            v-on:change="onChangeSupplier"
                            :disabled="true">
                            <v-list-tile v-if="form.supplierCode" slot="prepend-item" @click="form.supplierCode = null; form.supplierRFC = null;">
                                <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                                <v-list-tile-title>Limpiar</v-list-tile-title>
                            </v-list-tile>
                            <v-divider v-if="form.supplierCode" slot="prepend-item" class="mt-2"></v-divider>
                        </v-select>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="Nombre de Proveedor en Factura"
                            v-model="form.supplierName"
                            :disabled="view || isNational">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="RFC de Proveedor en Factura"
                            v-model="form.supplierRFC"
                            :disabled="view || isNational">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="O.C."
                            v-model="form.purchaseOrder"
                            :disabled="view || isNational">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="Total de Impuestos Trasladados"
                            :value="formatCurrency(form.totalTaxes)"
                            @input="debounceTotalTaxesInput($event)"
                            :disabled="view || isNational">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="No. Factura"
                            v-model="form.invoiceNum"
                            :disabled="view || isNational">
                        </v-text-field>
                    </v-flex>

                    <!-- ROW TWO -->
                    <v-flex xs12 sm3>
                        <v-menu
                            ref="date"
                            :close-on-content-click="false"
                            v-model="date"
                            :nudge-right="40"
                            :return-value.sync="form.date"
                            :disabled="view || isNational"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                            <v-text-field class="lance no-right-padding"
                                slot="activator"
                                :value="formatDate(form.date, true)"
                                label="Fecha de Documento"
                                append-icon="event"
                                :disabled="view || isNational"
                                readonly>
                            </v-text-field>
                            <v-date-picker v-model="form.date" no-title scrollable locale="es" :header-date-format="formatCalendarHeader">
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="form.date=null; $refs.date.save(form.date);">Cancelar</v-btn>
                                <v-btn flat color="primary" @click="$refs.date.save(form.date);">Aceptar</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="Total Factura"
                            :value="formatCurrency(form.total)"
                            @input="debounceTotalInput($event)"
                            :disabled="view || isNational">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="RFC Cliente"
                            v-model="form.clientRFC"
                            :disabled="view || isNational">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="RFC Proveedor"
                            v-model="form.supplier.rfc"
                            :disabled="true">
                        </v-text-field>
                    </v-flex>

                    <!-- ROW THREE -->
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="Moneda"
                            v-model="form.currency"
                            :disabled="view || isNational">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-select class="lance"
                            :items="status"
                            item-text="internalText"
                            item-value="id"
                            v-model="form.status"
                            label="Estatus"
                            :rules="[v => !!v || 'Campo requerido']"
                            disabled>
                            <v-list-tile v-if="form.status" slot="prepend-item" @click="form.status = null;">
                                <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                                <v-list-tile-title>Limpiar</v-list-tile-title>
                            </v-list-tile>
                            <v-divider v-if="form.status" slot="prepend-item" class="mt-2"></v-divider>
                        </v-select>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="Nom. Comercial Whirlpool"
                            v-model="form.clientName"
                            :disabled="view || isNational">
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm3 v-if="form.purchaseOrder">
                        <v-text-field class="lance"
                            label="Orden de Compra"
                            v-model="form.purchaseOrder"
                            :disabled="view || isNational">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 v-if="form.invoiceUUID">
                        <v-text-field class="lance"
                            label="UUID"
                            v-model="form.invoiceUUID"
                            :disabled="view || isNational">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 v-if="form.consignmentSheetNum">
                        <v-text-field class="lance"
                            :label="form.isVMI ? 'VMI Number' : 'Folio de Consignación'"
                            v-model="form.consignmentSheetNum"
                            :disabled="view || isNational">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 v-if="form.shipmentNum">
                        <v-text-field class="lance"
                            label="Folio de Shipment"
                            v-model="form.shipmentNum"
                            :disabled="view || isNational">
                        </v-text-field>
                    </v-flex>

                    <!-- ROW FOUR -->
                     <v-flex xs12 sm9>
                         <v-text-field class="lance"
                            label="Comentarios"
                            v-model="form.commentManual"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                </v-layout>

                <h4>L&iacute;neas
                    <v-btn v-if="!view && !isNational"
                        fab color="primary" 
                        @click="openAddDocumentLineModal()" 
                        style="width:40px; height:40px;">
                        <v-icon>add</v-icon>
                    </v-btn>
                </h4>

                <v-data-table
                    :headers="filteredHeaders"
                    :items="form.documentLines"
                    :loading="loading"
                    hide-actions
                    class="table-catalog elevation-5">
                    <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                    <template slot="items" slot-scope="props">
                        <tr @click="(!view && !isNational)? openEditLineModal(props): null">
                            <td class="text-xs-left">{{ props.item.productCode }}</td>
                            <td class="text-xs-left">{{ props.item.description }}</td>
                            <td class="text-xs-left">{{ form.purchaseOrder }}</td>
                            <td class="text-xs-left">{{ form.consignmentSheetNum }}</td>
                            <td class="text-xs-left">{{ props.item.quantity }}</td>
                            <td class="text-xs-left">{{ formatCurrency(props.item.price) }}</td>
                            <td class="text-xs-left">{{ formatCurrency(props.item.subTotal) }}</td>
                            <td class="text-xs-left total">{{ formatCurrency(Number(props.item.subTotal) + Number(props.item.taxes) - Number(props.item.withheldTaxTotal)) }}</td>
                            <td class="text-xs-left action-col" v-if="!view && !isNational">
                                <v-btn fab small color="error"
                                    style="width: 30px; height: 30px;"
                                    @click.stop="removeDocumentLine(props)">
                                    <img src="@/assets/icon-eliminar.svg" alt="">
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                    <template slot="no-data">
                        No hay registros para sus parámetros de búsqueda. Favor de intentar otra búsqueda o crear uno nuevo.
                    </template>
                </v-data-table>

                <v-layout row warp justify-center>
                    <v-flex xs12 md4>
                        <v-btn solo color="primary" @click="downloadFiles">Descargar Archivos</v-btn>
                    </v-flex>
                </v-layout>

                <v-layout v-if="workbook || (imageSources && imageSources.length)" justify-center row wrap>
                    <v-flex sm6>
                        <v-layout column>
                            <v-flex>
                                <h4>Documento</h4>
                            </v-flex>
                            <v-flex v-if="imageSources && imageSources.length">
                                <div class="elevation-5 card">
                                    <ImageSelect  
                                        style="width:100%;" 
                                        v-model="coords" 
                                        :imgSrc="imageSources[currentPage]"/>
                                </div>
                            </v-flex>
                            <v-flex v-if="imageSources && imageSources.length" align-self-center>
                                <v-btn fab color="primary" @click="currentPage--" :disabled="currentPage<=0">
                                    <v-icon>arrow_left</v-icon>
                                </v-btn>
                                <span>Página {{currentPage+1}} / {{imageSources.length}}</span>
                                <v-btn fab color="primary" @click="currentPage++" :disabled="currentPage>=imageSources.length-1">
                                    <v-icon>arrow_right</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex v-if="workbook">
                                <WorkbookGrid
                                    v-model="form.cell"
                                    v-if="workbook"
                                    :worksheet="workbook.Sheets[workbook.SheetNames[currentPage]]"/>
                            </v-flex>
                            <v-flex v-if="workbook" align-self-center>
                                <v-btn fab color="primary" @click="currentPage--" :disabled="currentPage<=0">
                                    <v-icon>arrow_left</v-icon>
                                </v-btn>
                                <span>Página {{currentPage+1}} / {{workbook.SheetNames.length}}</span>
                                <v-btn fab color="primary" @click="currentPage++" :disabled="currentPage>=workbook.SheetNames.length-1">
                                    <v-icon>arrow_right</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                
                <v-layout row wrap>
                    <v-flex xs12 md4>
                        <v-btn v-if="!view" solo color="submitBtn" @click="save()" :disabled="!valid || sending">Guardar</v-btn>
                    </v-flex>
                    
                    <v-flex xs12 md4>
                        <v-btn v-if="!view" solo color="primary" @click="cancelInvoice()" :disabled="!valid || sending">Cancelar</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>

        <DocumentLineModal v-if="documentLineDialog"
            v-model="documentLineDialog"
            :editData="tempDocumentLineData"
            @add="addDocumentLine"
            @edit="editDocumentLine"
            @cancel="cancelDocumentLine"
        ></DocumentLineModal>
    </div>
</template>

<style scoped>
    h4 {
        font-size: 20px;
        margin-bottom: 18px;
    }

    .comment-block > .v-input__control > .v-input__slot, .comment-block.v-text-field--solo > .v-input__control > .v-input__slot {
        border-radius: 20px !important;
    }

    .pre-wrap {
        font-size: 14px;
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word; 
        font-family: monospace;
    }

    .table-catalog {
        padding: 30px;
    }

    .table-catalog >>> table.v-table thead th:not(:first-child),
    .table-catalog >>> table.v-table tbody td:not(:first-child) {
        padding-left: 20px;
    }

    .table-catalog >>> table.v-table thead th.total:last-child,
    .table-catalog >>> table.v-table tbody td.total:last-child {
        white-space: nowrap;
    }

    .table-catalog >>> table.v-table thead tr th {
        font-size: 14px;
        font-weight: bold;
    }

    .table-catalog >>> table.v-table tbody tr td {
        font-size: 12px;
    }

    .table-catalog >>> table.v-table tbody tr td.total {
        white-space: nowrap;
    }

    td.action-col {
        border: none ;
        padding-left: 24px !important;
        max-width: 35px;
    }
</style>


<script>
    import { events } from '../main';
    import { _ } from 'underscore';
    import * as lod from 'lodash';
    import moment from 'moment-timezone';
    import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
    import PdfWorker from 'worker-loader?name=pdf.worker.[hash].js!pdfjs-dist/legacy/build/pdf.worker.js';
    import XLSX from 'xlsx';
    import ImageSelect from "./ImageSelect";
    import WorkbookGrid from "./WorkbookGrid";
    import DocumentLineModal from "./DocumentLineModal.vue";

    // Use the legacy build to avoid private fields (ES2022) issues on webpack 4
    pdfjsLib.GlobalWorkerOptions.workerSrc = PdfWorker;

    export default {
        components: {
            ImageSelect,
            WorkbookGrid,
            DocumentLineModal,
        },
        data() {
            return {
                suppliers: [],
                status: [],
                headers: [
                    { text: 'Código Producto', value: 'productCode' },
                    { text: 'Descripción', value: 'description' },
                    { text: 'O.C.', value: 'purchaseOrder' },
                    { text: 'Folio de consignación', value: 'consignmentSheetNum' },
                    { text: 'Cantidad', value: 'quantity' },
                    { text: 'P. Unitario', value: 'price' },
                    { text: 'Importe', value: 'subTotal' },
                    { text: 'Total', value: 'subTotal + taxes' },
                    { text: '', value: '', sortable: false, edit: true },
                ],
                imageSources: [],
                workbook: null,
                xmlData: null,
                currentPage: 0,
                coords: {
                    x1: null,
                    y1: null,
                    x2: null,
                    y2: null,
                },
                loading: true,
                valid: true,
                sending: false,
                view: false,
                isNational: false,
                date: false,
                id: '',
                title: '',
                form: {
                    documentLines: [],
                },
                credentials: JSON.parse(localStorage.getItem('userCredentials')),
                documentLineDialog: false,
                tempDocumentLineData: null,
                tempDocumentLineIdx: null,
            }
        },
        methods: {
            snackbar(message) {
                events.$emit('snackbar', message);            
            },
            goTo(url) {
                this.$router.push(url);
            },
            goBack () {
                window.history.length > 1
                    ? this.$router.go(-1)
                    : this.$router.push('/')
            },
            formatCalendarHeader(val) {
                return moment(val).locale("es").format("MMMM YYYY");
            },
            formatDate(date, withUtc=false) {
                if(date) {
                    let mdate = moment(date);
                    if (withUtc) mdate = mdate.utc();
                    var ndate = mdate.locale("es-mx").format("DD/MMM/YYYY");
                    var mes = ndate.split("/")[1];
                    var nmes = mes.charAt(0).toUpperCase() + mes.slice(1, -1);
                    return ndate.replace(mes, nmes);
                }
                return '';
            },
            formatTime(date) {
                return date ? moment(date).locale("es").format("HH:mm:ss a") : '';
            },
            debounceTotalTaxesInput: lod.debounce(function ($event) {
                this.form.totalTaxes = this.getNumericValue($event)
            }, 500),
            debounceTotalInput: lod.debounce(function ($event) {
                this.form.total = this.getNumericValue($event)
            }, 500),
            formatCurrency(num) {
                return "$ " + Number(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            },
            getNumericValue: (value) => {
                return parseFloat(value.replace(/[\$\s,]/g, ''));
            },
            getStatuses: function() {
                this.$http.get('Status/')
                    .then(response => {
                        var list = response.body;
                        this.status = list;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista de estatus');
                        console.error(error);
                    })
            },
            getSuppliers: function() {
                this.$http.get('Documents/Suppliers')
                    .then(response => {
                        var list = response.body;
                        this.suppliers = list;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista de proveedores');
                        console.error(error);
                    })
            },
            dataInit() {
                this.getSuppliers();
                this.getStatuses();
                this.getRegistry(this.id);
            },
            getRegistry(id) {
                this.$http.get('Documents/form/' + this.id)
                .then(response => {
                    this.form = response.body.Documents;
                    if (response.body.Documents.documentLines.length > 0) {
                        response.body.Documents.documentLines.forEach((line, index, linesArray) => linesArray[index].index = index)
                    }
                    this.isNational = this.form.supplier.supplierTypeId == 1;
                    this.loading = false;
                    this.loadFile();
                }, error => {
                    this.snackbar(this.$t('message.documents.messages.formLoadError'));
                    this.goBack();
                });
            },
            loadFile() {
                var fileLocation = '';
                var fileId = '';
                if (this.form.emailAttachment) {
                    fileLocation = 'email';
                    fileId = this.form.sourceEmailAttach;
                } else if (this.form.supplierFile) {
                    fileLocation = 'SupplierFiles';
                    fileId = this.form.sourceSupplierFile;
                }

                if (fileLocation != '') {
                    this.$http.get(fileLocation + '/getattachment/' + fileId, {responseType: "blob"})
                    .then(response => {
                        var fileType = response.headers.get('Content-Type');
                        let file = new Blob([response.data], { type: response.headers.get('Content-Type') });
                        var reader = new FileReader();
                        if (fileType == "application/pdf") {
                            reader.onload = () => {
                                let docTask = pdfjsLib.getDocument(reader.result);
                                docTask.promise.then( pdfDoc => {
                                    let pagePromises = [];
                                    for (let i=1; i<=pdfDoc.numPages; i++) {
                                        pagePromises.push(pdfDoc.getPage(i));
                                    }
                                    return Promise.all(pagePromises);
                                }).then( pages => {
                                    pages.forEach(page => {
                                        let viewport = page.getViewport({ scale: 1.0, rotation: 180, dontFlip: true });
                                        let canvas = document.createElement("canvas");
                                        let canvasContext = canvas.getContext("2d");
                                        canvas.width = viewport.width = page.view[2];
                                        canvas.height = viewport.height = page.view[3];
                                        page.render({ canvasContext, viewport }).then( () => {
                                            canvasContext.translate(0, canvas.height);
                                            canvasContext.scale(1, -1);
                                            canvasContext.drawImage(canvas, 0, 0);
                                            this.imageSources.splice(page.pageIndex, 0, canvas.toDataURL("image/png"));
                                        });
                                    });
                                });
                            };
                            reader.readAsArrayBuffer(file);
                        } else if (fileType.indexOf("excel")!=-1 || fileType.indexOf("csv")!=-1 || fileType.indexOf("spreadsheet")!=-1) {
                            reader.onload = () => {
                                this.workbook = XLSX.read(new Uint8Array(reader.result), { type: "array" });
                            };
                            reader.readAsArrayBuffer(file);
                        } else if (fileType.indexOf("text/xml")!= -1) {
                            reader.onload = () => {
                                this.xmlData = reader.result;
                            };
                            reader.readAsText(file);
                        } else {
                            reader.onload = () => {
                                this.imageSources = [reader.result];
                            };
                            reader.onerror = error => console.error(error);
                            reader.readAsDataURL(file);
                        }
                    });
                }
            },
            onChangeSupplier(sender) {
                let supplier = this.suppliers.find(x => x.code == sender);
                if (supplier) {
                    this.form.supplierRFC = supplier.rfc;
                } else {
                    this.form.supplierRFC = null;
                }
            },
            onChangeRFC(sender) {
                let supplier = this.suppliers.find(x => x.rfc == sender);
                if (supplier) {
                    this.form.supplierCode = supplier.code;
                } else {
                    this.form.supplierCode = null;
                }
            },
            openAddDocumentLineModal() {
                this.tempDocumentLineData = null;
                this.tempDocumentLineIdx = null;
                this.documentLineDialog = true;
            },
            addDocumentLine(newLine) {
                this.documentLineDialog = false;
                newLine.lineNumber = this.form.documentLines.length;
                newLine.index = Math.max(...(this.form.documentLines ? this.form.documentLines.map(line => line.index) : [0])) + 1;
                this.form.documentLines.push(newLine);
                this.$forceUpdate();
            },
            openEditLineModal(prop) {
                this.tempDocumentLineData = prop.item;
                this.tempDocumentLineIdx = prop.item.index;
                this.documentLineDialog = true;
            },
            editDocumentLine(newLine) {
                this.documentLineDialog = false;
                const editLine = this.form.documentLines.find((line, index) => line.index == this.tempDocumentLineIdx);
                Object.assign(editLine, newLine);
                this.tempDocumentLineData = null;
                this.tempDocumentLineIdx = null;
                this.$forceUpdate();
            },
            cancelDocumentLine() {
                this.tempDocumentLineData = null;
                this.tempDocumentLineIdx = null;
                this.documentLineDialog = false;
            },
            removeDocumentLine(prop) {
                let idx = this.form.documentLines.findIndex(x => x.index == prop.item.index)
                this.form.documentLines.splice(idx, 1);
                for (let i=0; i<this.form.documentLines; i++) {
                    this.form.documentLines[i].lineNumber = i+1;
                }
            },
            save() {
                if (this.$refs.form.validate()) {
                    this.sending = true;
                    this.$http.put('Documents/' + this.id, this.form)
                        .then(response => {
                            this.snackbar(this.$t('message.documents.messages.formUpdateSuccess'));
                            this.goBack();                               
                        }, error => {
                            if(error.body ? error.body.type === 'SAPconnectionError' : false) {
                                this.snackbar(error.body.msg);
                                this.goBack();
                                return;
                            }
                            this.sending = false;                                
                            this.snackbar(this.$t('message.documents.messages.formUpdateError'));
                            console.error(error);
                    });
                }
            },
            cancelInvoice() {
                if (this.$refs.form.validate()) {
                    this.sending = true;
                    this.$http.put(`Documents/cancel/${this.id}`, this.form)
                    .then(response => {
                        this.snackbar(this.$t('message.documents.messages.formCancelSuccess'));
                        this.goBack();
                    }).catch(error => {
                        this.snackbar(this.$t('message.documents.messages.formCancelError'));
                    }).finally(() => {
                        this.sending = false;
                    });
                }
            },
            downloadFiles() {
                this.$http.get(`Documents/getFiles/${this.id}`, { responseType: "blob" }).then( result => {
                    let blob = new Blob([result.data], { type: result.headers.get('Content-Type') });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "documentos.zip";
                    link.click();
                }).catch(error => {
                    this.snackbar(this.$t('message.documents.messages.formDownloadError'));
                });
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.$route.name.includes('detail') ) {
                this.view = true;
                this.title = "Detalle";
            } else if (this.$route.name.includes('edit')) {
                this.view = false;
                this.title = "Editar";
            }
            this.dataInit();
        },
        filters: {
            moment: function (date) {
                return moment(date).locale("es").format('LL');
            }
        },
        computed: {
            filteredHeaders() {
                return this.headers.filter(h => h.edit === undefined || (h.edit === true && !this.view && !this.isNational));
            }
        }
    }
</script>